import { Stack, SimpleGrid } from '@mantine/core';
import { CountStepper } from '../UI/CountStepper';

type FamilySizePreferenceProps = {
  value: { adults: number; kids: number };
  onChange: (value: { adults: number; kids: number }) => void;
};

export const FamilySizePreference = ({ value, onChange }: FamilySizePreferenceProps) => {
  return (
    <Stack gap="xl">
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xl">
        <CountStepper
          label="Adults"
          description="Including yourself"
          value={value.adults}
          onChange={(adults) => onChange({ ...value, adults })}
          min={1}
          max={10}
        />

        <CountStepper
          label="Kids"
          description="Children and teenagers"
          value={value.kids}
          onChange={(kids) => onChange({ ...value, kids })}
          min={0}
          max={10}
        />
      </SimpleGrid>
    </Stack>
  );
};
